import { useLocation, useNavigate } from 'react-router-dom';
import { AiOutlineZoomIn, AiOutlineZoomOut } from 'react-icons/ai';
import { useDispatch, useSelector } from 'react-redux';
import {
  addComment,
  selectCommentData,
  addNote,
  selectActiveEntityId,
  setActiveEntityId,
  toggleNoteMode,
  selectIsNotMode,
  selectNotes,
  clearNotes,
} from '../../redux/notesetting/notesSettingsSlice';
import { Button, Col, Modal, Row, Segmented, Spin, Popconfirm, Tooltip } from 'antd';
import UilCommentAlt from '@iconscout/react-unicons/icons/uil-comment-alt';
import '../../static/css/Notes.css';
import * as Switch from '@radix-ui/react-switch';
import { useEffect, useState } from 'react';
import { get, post, del } from '../../config/dataService/dataService';
import { Cards } from '../../components/cards/frame/cards-frame';
import { ActivityContents } from '../../container/profile/myProfile/overview/Style';
import { QuestionCircleOutlined, RollbackOutlined, LeftOutlined, RightOutlined } from '@ant-design/icons';
import { PageHeader } from '../../components/page-headers/page-headers';
import moment from 'moment';
import { CardToolbox, Main } from '../../container/styled';
import { DataTableStyleWrap } from '../../components/table/Style';
import ExternalPage from './ExternalPage';
import { MessageType, showNotification } from '../../app_components/common/CommonStyle';
import Checklist from '../checklist/Checklist';
import { Popover } from '../../components/popup/proofCommentInfoPopup';
import UilTrash from '@iconscout/react-unicons/icons/uil-trash';

const ExternalReviewImage = ({
  workflowContactId: propWorkflowContactId,
  proofId: propProofId,
  contactType: propContactType,
  imageData: propImageData,
  handleBack,
  onReloadProofList,
  images: propImages = [],
  currentIndex: propCurrentIndex = 0,
}) => {
  const urls = {
    getcommentByImageid: 'PublicExternalProof/GetCommentsByProofId',
    updateClassApproval: 'PublicExternalProof/Updateclassapproval',
    deleteComment: 'PublicExternalProof/DeleteCommentById',
  };

  const approvalEnums = {
    Reject: 0,
    Approved: 1,
    Pending: 2,
    ApprovedWithComments: 3,
  };

  const location = useLocation();
  const {
    workflowContactId: stateWorkflowContactId,
    proofId: stateProofId,
    contactType: stateContactType,
    imageData: stateImageData,
    images: stateImages = [],
    currentIndex: stateCurrentIndex,
  } = location.state || {};
  const [showChecklist, setShowChecklist] = useState(false);

  const workflowContactId = stateWorkflowContactId || propWorkflowContactId;
  const proofId = stateProofId || propProofId;
  const contactType = stateContactType || propContactType;
  const baseImageData = stateImageData || propImageData;
  const dispatch = useDispatch();
  const isNoteMode = useSelector(selectIsNotMode);
  const isCommentMode = useSelector(selectCommentData);
  const [zoomLevel, setZoomLevel] = useState(1);
  const [loading, setLoading] = useState(true);
  const [commentsData, setCommentsData] = useState([]);
  const [showThankYouModal, setShowThankYouModal] = useState(false);
  const [showApprove, setShowApprove] = useState(false);
  const navigate = useNavigate();
  const [approvedimage] = useState(1);
  const [approvedwithcomments] = useState(3);
  const [isCommentAvailable, setIsCommentAvailable] = useState(null);
  const [isLoadingForApprove, setisLoadingForApprove] = useState(true);
  const [showBackWarning, setShowBackWarning] = useState(false);
  const resolvedImages = stateImages.length ? stateImages : propImages;
  const safeResolvedIndex =
    resolvedImages.length && stateCurrentIndex !== undefined && stateCurrentIndex < resolvedImages.length
      ? stateCurrentIndex
      : resolvedImages.length && propCurrentIndex < resolvedImages.length
        ? propCurrentIndex
        : 0;
  const resolvedImage =
    (resolvedImages.length && resolvedImages[safeResolvedIndex]) || baseImageData;
  const [images] = useState(resolvedImages.length ? resolvedImages : resolvedImage ? [resolvedImage] : []);
  const [currentIndex, setCurrentIndex] = useState(resolvedImages.length ? safeResolvedIndex : 0);
  const [imageData, setImageData] = useState(
    resolvedImages.length ? resolvedImages[safeResolvedIndex] : resolvedImage,
  );

  const handleZoomIn = () => {
    setZoomLevel((prev) => Math.min(prev + 0.1, 3));
  };

  const handleZoomOut = () => {
    setZoomLevel((prev) => Math.max(prev - 0.1, 0.5));
  };

  const getNextPendingIndex = (currentIndex, images) => {
    for (let i = currentIndex + 1; i < images.length; i++) {
      if (images[i].IsApproved === approvalEnums.Pending) {
        return i;
      }
    }
    return -1;
  };

  const getPrevPendingIndex = (currentIndex, images) => {
    for (let i = currentIndex - 1; i >= 0; i--) {
      if (images[i].IsApproved === approvalEnums.Pending) {
        return i;
      }
    }
    return -1;
  };

  const nextPendingIndex = getNextPendingIndex(currentIndex, images);
  const infoPrevPendingIndex = getPrevPendingIndex(currentIndex, images);

  const hasPrev = infoPrevPendingIndex !== -1;
  const hasNext = nextPendingIndex !== -1;

  const handlePrev = () => {
    if (!hasPrev) return;
    const newIndex = infoPrevPendingIndex;
    setCurrentIndex(newIndex);
    setCommentsData([]);
    setImageData(images[newIndex]);
  };

  const handleNext = () => {
    if (!hasNext) return;
    const newIndex = nextPendingIndex;
    setCurrentIndex(newIndex);
    setCommentsData([]);
    setImageData(images[newIndex]);
  };

  const handleApprove = () => {
    updateClassApproval(approvedimage);
  };
  const handleApprovewithcomments = () => {
    updateClassApproval(approvedwithcomments);
  };

  const updateClassApproval = async (isapproved) => {
    try {
      setLoading(true);
      const payload = {
        versionNo: 0,
        proofId: proofId,
        isApproved: isapproved,
        proofWorkflowContactId: workflowContactId,
        versionmapingImageId: imageData?.VersionmapingImageId,
      };

      const result = await post(urls.updateClassApproval, payload);
      if (result.flag) {
        setLoading(false);
        setShowThankYouModal(true);
        setTimeout(() => {
          dispatch(setActiveEntityId(imageData?.VersionmapingImageId));
        }, 2000);
      } else {
        setLoading(false);

        showNotification(MessageType.Error, result.message);
      }
    } catch (errorInfo) {
      setLoading(false);

      showNotification(MessageType.CatchError, '');
    }
  };

  const GetcommentByImageId = async (imageid, proofId, versionNo) => {
    setisLoadingForApprove(true);
    try {
      const response = await get(
        `${urls.getcommentByImageid}?imageId=${imageid}&proofId=${proofId}&versionId=${versionNo}`,
      );
      const responseData = response?.data;
      if (responseData.length < 1) {
        setShowApprove(true);
      }
      if (responseData && responseData.length > 0) {
        setIsCommentAvailable(true); //Comments exist
        setCommentsData(responseData);
      }
      else if (responseData.length === 0) {
        setIsCommentAvailable(false);
        setCommentsData([]); //No comments
      }
      else {
        console.error('API call unsuccessful:', responseData?.message);
      }
    } catch (error) {
      console.error('Error fetching data:', error);
    }
    setisLoadingForApprove(false);
  };

  useEffect(() => {
    dispatch(clearNotes());
    if (!imageData?.ImageId) {
      setLoading(false);
      return;
    }

    setCommentsData([]);
    setLoading(true);

    GetcommentByImageId(imageData?.ImageId, imageData?.ProofId, imageData?.VersionNo);
    if (!isNoteMode) {
      dispatch(clearNotes());
      dispatch(toggleNoteMode());
    }
  }, [imageData?.ImageId]);

  useEffect(() => {
    dispatch(clearNotes());
    if (isNoteMode && commentsData.length > 0) {
      // dispatch(clearNotes());
      commentsData.forEach((comment, index) => {
        const coords = {
          x: { size: comment.x, unit: 'vw' },
          y: { size: comment.y, unit: 'vh' },
        };

        const text = comment.comments?.[0]?.description || '';
        const noteId = comment.commentBlockId;
        const targetSelector = '.ant-spin-container';

        dispatch(addNote({ coords, targetSelector, text, noteId }));

        if (index === 0) {
          dispatch(setActiveEntityId(noteId));
        }
      });
    }
  }, [isNoteMode, commentsData, imageData?.ImageId]);

  useEffect(() => {
    GetcommentByImageId(imageData?.ImageId, imageData?.ProofId, imageData?.VersionNo);
  }, [isCommentMode]);

  if (!imageData?.ImageURL) {
    return <div>No image provided.</div>;
  }

  const handledeleteComment = async (commentId) => {
    try {
      setLoading(true);
      const result = await del(`${urls.deleteComment}?id=${commentId}`);
      if (result.flag) {
        showNotification(MessageType.Success, result.message);
        GetcommentByImageId(imageData?.ImageId, imageData?.ProofId, imageData?.VersionNo);
      } else {
        showNotification(MessageType.Error, result.message);
      }
    } catch (error) {
      showNotification(MessageType.CatchError, '');
    }
    setLoading(false);
  };

  return (
    <>
      {/* <Checklist
        open={showChecklist}
        onContinue={() => handleApprove()}
        buttonLabel="Accept & Continue"
        onClose={() => setShowChecklist(false)}
      /> */}
      <CardToolbox style={{ margin: '10px' }}>
        <PageHeader
          title={
            <span style={{ display: 'flex', alignItems: 'center', gap: 10 }} onClick={(e) => e.stopPropagation()}>
              External Review Proof Image
              <Popover placement="bottomLeft" title="Review Comment Instructions">
                <Button
                  shape="round"
                  style={{
                    fontSize: 14,
                    color: '#ff1818ff',
                    cursor: 'pointer',
                  }}
                >
                  Review Comment Instructions
                </Button>
              </Popover>
            </span>
          }
          buttons={[
            <div
              style={{
                display: 'flex',
                justifyContent: 'flex-end',
                gap: '10px',
                marginBottom: '20px',
              }}
            >
              {contactType === 'approver' ? (
                <Button className="btn-add_new" type="primary" onClick={() => setShowChecklist(true)}>
                  Submit Job
                </Button>
              ) : (
                <>
                  <Button
                    shape="round"
                    type="primary"
                    onClick={() => setShowChecklist(true)}
                    disabled={isLoadingForApprove || isCommentAvailable}
                  >
                    Approve
                  </Button>
                  <Button
                    shape="round"
                    type="primary"
                    onClick={() => handleApprovewithcomments()}
                    disabled={isLoadingForApprove || !isCommentAvailable}
                  >
                    Approve with Comments
                  </Button>
                </>
              )}
            </div>,
            <div className="page-header-actions">
              <Button
                size="small"
                className="btn-add_new"
                type="secondary"
                icon={<LeftOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  handlePrev();
                }}
                disabled={!hasPrev}
                style={{ color: 'black', backgroundColor: 'white' }}
              >
                Previous
              </Button>
              <Button
                size="small"
                className="btn-add_new"
                type="secondary"
                icon={<RightOutlined />}
                onClick={(e) => {
                  e.stopPropagation();
                  handleNext();
                }}
                disabled={!hasNext}
                style={{ color: 'black', backgroundColor: 'white' }}
              >
                Next
              </Button>
              <Button
                size="small"
                className="btn-add_new"
                type="secondary"
                style={{ color: 'black', backgroundColor: 'white' }}
                onClick={() => {
                  setShowBackWarning(true);
                }}
              >
                <RollbackOutlined />
                Back
              </Button>
            </div>,
          ]}
        />
      </CardToolbox>

      <Main>
        <Row gutter={15}>
          <Col xs={24}>
            {/* <Spin spinning={loading}> */}
            <Cards headless>
              <DataTableStyleWrap>
                <div className="ninjadash-datatable-filter">
                  <div className="ninjadash-datatable-filter__left page-header-actions custom-get-review-image-header">
                    <div className="mode-switch">
                      <label htmlFor="note-mode">Comments</label>

                      <Segmented
                        value={isNoteMode ? 'Show' : 'Hide'}
                        options={['Hide', 'Show']}
                        onChange={(val) => dispatch(toggleNoteMode(val === 'Show'))}
                        style={{
                          marginBottom: 8,
                        }}
                      />
                    </div>
                    <Button
                      size="small"
                      // data-zoom-button
                      onClick={handleZoomOut}
                      className="btn-add_new zoom-button"
                      type="secondary"
                    >
                      <AiOutlineZoomOut />
                      Zoom Out
                    </Button>
                    <Button
                      size="small"
                      // data-zoom-button
                      onClick={handleZoomIn}
                      className="btn-add_new zoom-button"
                      type="secondary"
                    >
                      <AiOutlineZoomIn />
                      Zoom In
                    </Button>
                  </div>
                  <div className="ninjadash-datatable-filter__right"></div>
                </div>
              </DataTableStyleWrap>

              <div className="custom-get-review-image">
                <div className="notes-container" style={{ display: 'flex', width: '100%', gap: '2rem' }}>
                  <div className="wrapper">
                    <ExternalPage
                      setCommentsData={commentsData}
                      imageData={imageData}
                      workflowContactId={workflowContactId}
                      zoomLevel={zoomLevel}
                    >
                      <div
                        className="zoom-container"
                        style={{
                          transform: `scale(${zoomLevel})`,
                          transformOrigin: 'top left',
                        }}
                      >
                        <div className="hero">
                          <Spin spinning={loading}>
                            <img
                              src={imageData?.ImageURL}
                              alt="Review"
                              onLoad={() => setLoading(false)}
                              onError={() => setLoading(false)}
                            />
                          </Spin>
                        </div>
                      </div>
                    </ExternalPage>
                  </div>
                  <ActivityContents className="comment-section">
                    <Cards headless>
                      {(commentsData || [])
                        .flatMap((block) => block?.comments)
                        .sort((a, b) => new Date(b?.createdDateTime) - new Date(a?.createdDateTime))
                        .map((block) => {
                          // const sortedComments = [...(block.comments || [])].sort(
                          //   (a, b) => new Date(b?.createdDateTime) - new Date(a?.createdDateTime),
                          // );

                          return (
                            <ul className="activity-list" key={`block-${block?.commentId}`}>
                              {/* {sortedComments.map((comment) => ( */}
                              <li className="activity-list__single" key={`comment-${block?.commentId}`}>
                                <span className="activity-icon primary">
                                  <UilCommentAlt />
                                </span>
                                <div className="activity-content">
                                  <div className="activity-info">
                                    <img src={require('../../static/img/No_image_available.png')} alt="user" />
                                    <p>
                                      <span className="inline-text color-primary">{block?.createdBy}</span>{' '}
                                      {moment(block?.createdDateTime).format('MM/DD/YYYY')}
                                      <br />
                                      <span
                                        className="hour"
                                        style={{ textWrap: 'break-word', overflowWrap: 'anywhere' }}
                                      >
                                        {block?.description}
                                      </span>
                                    </p>
                                  </div>
                                </div>
                                <div onClick={e => e.stopPropagation()} hidden={block.proofWorkflowContactId !== workflowContactId}>
                                  <Popconfirm
                                    title="Are you sure to Delete?"
                                    onConfirm={() => handledeleteComment(block?.commentId)}
                                    okText="Yes"
                                    cancelText="No"
                                  >
                                    <Tooltip placement="top" title="Delete">
                                      <UilTrash
                                        style={{ cursor: 'pointer', color: 'red', marginLeft: '10px' }}
                                      />
                                    </Tooltip>
                                  </Popconfirm>
                                </div>
                              </li>
                              {/* ))} */}
                            </ul>
                          );
                        })}
                    </Cards>
                  </ActivityContents>
                </div>
              </div>
            </Cards>
            {/* </Spin> */}
          </Col>
        </Row>
      </Main>
      <div className="thank-you-modal-wrapper">
        <Modal
          open={showThankYouModal}
          onCancel={() => {
            setShowThankYouModal(false);
            if (onReloadProofList) onReloadProofList();
            handleBack();
          }}
          closable
          footer={null}
          keyboard={false}
          centered
        >
          <div
            style={{
              textAlign: 'center',
              padding: '2rem',
              fontFamily: 'Segoe UI, sans-serif',
            }}
          >
            <h2
              style={{
                fontSize: '24px',
                fontWeight: '600',
                marginBottom: '1rem',
                color: '#1890ff',
              }}
            >
              Thank you!
            </h2>
            <p
              style={{
                fontSize: '16px',
                color: '#555',
                lineHeight: '1.6',
                maxWidth: '400px',
                margin: '0 auto',
              }}
            >
              Your image approval has been recorded successfully.
              <br />
            </p>
          </div>
        </Modal>
      </div>
      <Modal
        open={showChecklist}
        title="Proof Approval Confirmation"
        closable
        onCancel={() => setShowChecklist(false)}
        onOk={() => handleApprove()}
        centered
      >
        <div className="checklist-item">
          <h3>These changes will be submitted and will not be able to be undone once submitted.</h3>
        </div>
      </Modal>
      <Modal
        title="Warning"
        open={showBackWarning}
        maskClosable={false}
        destroyOnClose={true}
        onCancel={() => setShowBackWarning(false)}
        footer={[
          // <Button
          //   key="cancel"
          //   onClick={() => {
          //     // Go back
          //     setShowBackWarning(false);
          //     handleBack();
          //   }}
          // >
          //   Don't want to submit yet!
          // </Button>,

          <Button
            key="ok"
            type="primary"
            onClick={(e) => {
              e.stopPropagation();
              // Stay on page
              setShowBackWarning(false);
            }}
          >
            Ok
          </Button>,
        ]}
      >
        <p onClick={(e) => e.stopPropagation()}>
          {`Click Approve${isCommentAvailable ? ' with Comments' : ''} in order to submit the changes.`}
        </p>
      </Modal>
    </>
  );
};

export default ExternalReviewImage;
